import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as menteesRequestAction from "../../actions/menteesRequestAction";
import * as settingActions from "../../actions/settingActions";
import * as baseActions from "../../actions/baseActions";
import { Button, Col, Dropdown } from "react-bootstrap";
import UserSidebar from "../../Component/UserSidebar";
import Slider from "react-slick";
import Moment from "moment";
import Details from "./details";
import { getSubdomainPath, UCObjective, UCWords } from "../../utils/helpers";
import Relationship from "./relationship";
import DToolkit from "./dtoolkit";
import Feedback from "../MenteesLog/Feedback";
import ReportUser from "../Forum/reportUser";
import MentoringSession from "../../Component/MentoringSession";
import { Tooltip } from "@mui/material";
import config from "../../config";
import NoImage from '../../assets/images/noImage.png'
import rainbow from '../../assets/images/rainbow.png'
import ScheduleMeetingModal from "./scheduleMeetingModal";
import { imgPath } from "../../utils/imagePath";
import queryString from "query-string";
import { ref, get, set } from "firebase/database";
import { database } from "../../Firebase";
import PropTypes from "prop-types";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ border: "none", backgroundColor: "white" }}
  >
    {children}
    <span className="threedots" />
  </button>
));

CustomToggle.displayName = "CustomToggle";

CustomToggle.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};

const Index = (props) => {

  const { title, actions, menteeRequestData, userInfo, pagination, setting, steps_labels } = props;
  const [room, setRoom] = useState({ roomname: "" });

  const Mentors_details = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    unslick: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          unslick: false,
        },
      },
    ],
  };

  const [userData, setUserData] = useState({});
  const [endRelationship, setEndRelationship] = useState({});

  const writeReview = (e, mentee_id, mentor_id, review) => {
    e.preventDefault();
    setModalShow(true);
    setUserData({
      mentee_id: mentee_id,
      mentor_id: mentor_id,
      mentor_review: review,
    });
  };

  const endRelationshipModal = (e, mentee_id, mentor_id, review, actionid) => {
    e.preventDefault();
    setRelationModalShow(true);
    setEndRelationship({
      mentee_id: mentee_id,
      mentor_id: mentor_id,
      mentor_review: review,
      actionid: actionid,
    });
  };

  const [modalShow, setModalShow] = useState(false);
  const [relationModalShow, setRelationModalShow] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [sessionModel, setSessionModel] = useState(false);

  const subDomainPath = getSubdomainPath();

  const location = useLocation();
  const history = useNavigate();

  const refreshMentors = () => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("sort")) {
      const sort = queryStringParsed["sort"];
      const direction = queryStringParsed["direction"];
      request.sort = sort;
      request.direction = direction;
    }
    if (params.get("page")) {
      const page = queryStringParsed["page"];
      request.page = page;
    }
    if (params.get("keyword")) {
      const keyword = queryStringParsed["keyword"];
      request.keyword = keyword;
    }
    document.title = title;
    actions.loadRegData(request, 4);
  };

  useEffect(() => {
    refreshMentors();
  }, [title, actions, location]);

  const downloadResume = (e, url) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (room.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [room, history]);

  const handleClickChat = async (item) => {
    try {
      const db = database; // already initialized

      const roomUser =
        item.mentor_id > item.mentee_id
          ? `${item.mentor_id}_${item.mentee_id}`
          : `${item.mentee_id}_${item.mentor_id}`;

      const time = Moment.utc().valueOf();

      const message = {
        mentor_name: item.mentor_name,
        mentor_image: userInfo.image,
        mentor_id: item.mentor_id,
        mentee_name: item.mentee_name,
        mentee_image: item.mentee_image,
        mentee_id: item.mentee_id,
        device_type: "Web",
        message: "",
        key: roomUser,
        role_id: userInfo.role_id,
        status: 0,
        time: Moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
        epoch: -1 * time,
      };

      setRoom({ roomname: roomUser });

      const mentorRef = ref(db, `users/${item.mentor_id}/${roomUser}`);
      const menteeRef = ref(db, `users/${item.mentee_id}/${roomUser}`);

      if (!(await get(mentorRef)).exists()) {
        await set(mentorRef, message);
      }

      if (!(await get(menteeRef)).exists()) {
        await set(menteeRef, message);
      }
    } catch (error) {
      console.error("Error initializing chat:", error);
    }
  };

  const [toolkitData, setToolkitData] = useState({});

  const viewToolkit = (
    e,
    mentee_id,
    mentor_id,
    diagnostics,
    diagnostics_sdate
  ) => {
    e.preventDefault();
    setToolkitModalShow(true);
    setToolkitData({
      mentee_id: mentee_id,
      mentor_id: mentor_id,
      mentee_diagnostics: diagnostics,
      diagnostics_sdate: diagnostics_sdate,
    });
  };

  const [toolkitModalShow, setToolkitModalShow] = useState(false);
  const [modelData, setModelData] = useState("");
  const [model, setModel] = useState(false);
  const [userData2, setUserData2] = useState({});
  const [scheduleUser, setScheduleUser] = useState({})
  const [reportModalShow, setReportModalShow] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const viewReportModal = (e, item) => {
    e.preventDefault();
    setReportModalShow(true);
    setUserData2({ item: item, from: "user" });
  };


  const handleSchedule = (e, item) => {
    e.preventDefault();
    setScheduleModal(true)
    setScheduleUser(item)
  }

  const isEmptyValue = (value) => {
    return (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null" ||
      value === "undefined"
    );
  };

  const getFieldValue = (item, keys = []) => {

    for (const key of keys) {

      // reg_fields
      if (
        item?.reg_fields?.[key] !== undefined &&
        item?.reg_fields?.[key] !== null &&
        item?.reg_fields?.[key] !== ""
      ) {
        return item.reg_fields[key];
      }

      // direct item
      if (
        item?.[key] !== undefined &&
        item?.[key] !== null &&
        item?.[key] !== ""
      ) {
        return item[key];
      }
    }

    return null;
  };

  const normalizeArray = (value) => {

    if (!value) return [];

    // array
    if (Array.isArray(value)) {

      return value
        .map((item) => {

          if (typeof item === "object") {

            return (
              item?.title ||
              item?.label ||
              item?.name ||
              item?.rep_board_title ||
              item?.rep_company_name ||
              ""
            );
          }

          return item;
        })
        .filter(Boolean);
    }
    // string
    // if (typeof value === "string") {
    //   return value
    //     .split(",")
    //     .map((item) => item.trim())
    //     .filter(Boolean);
    // }

    if (typeof value === "string") {
      return value
        .split(/\|\||,/)
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return [];
  };

  const callAFun = (field) => {
    setPopupMessage("You have already raised the termination request. Please wait for the admin to review");
    setShowPopup(true);
    return false
  };

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h2 className="dash_heading">Current Mentees</h2>
          <div className="box_wrap shadow-sm bg-white mentor_box">
            <Slider {...Mentors_details}>
              {(Array.isArray(menteeRequestData) ? menteeRequestData : []).map((item) => {
                const fieldMap = {

                  objective: {
                    label: "Objectives",
                    type: "array",
                  },

                  about: {
                    label: "About Me",
                    type: "text",
                  },

                  program_study_id: {
                    label: "Program of Study",
                    type: "text",
                  },

                  board_entity_type: {
                    label: "Board Entity Type Experience",
                    type: "array",
                  },

                  years_of_board_experience: {
                    label: "Year of Board Experience",
                    type: "text",
                  },

                  accredited_director: {
                    label: "SID Accredited Director",
                    type: "array",
                  },

                  course_completed: {
                    label: "Course Completed",
                    type: "array",
                  },

                  indicate_board_experience_level: {
                    label: "Board Experience Level",
                    type: "text",
                  },

                  language: {
                    label: "Language",
                    type: "text",
                  },

                  country: {
                    label: "Country",
                    type: "text",
                  },

                  current_course: {
                    label: "Current Course",
                    type: "text",
                  },

                  industry_id: {
                    label: "Industry",
                    type: "text",
                  },

                  university_partners_id: {
                    label: "University",
                    type: "text",
                  },

                  experience_levels: {
                    label: "Experience Levels",
                    type: "array",
                  },

                  domains: {
                    label: "Domains",
                    type: "array",
                  },

                  past_board_roles: {
                    label: "Current / Past Board Roles",
                    type: "array",
                  }

                };

                // skip unwanted fields
                const hiddenFields = new Set([
                  "image",
                  "resume",
                  "email",
                  // "number",
                  // "dob",
                  "linkedin",
                  "is_terms",
                  "is_privacy",
                  "training_video",
                  "my_consent",
                  "role_id",
                  "mn_open_to_talk",
                  "mn_loking_for_coach",
                  "first_name",
                  "last_name",
                  "full_name",
                  // "position",
                  // "organization",
                  // "domains",
                ]);

                // console.log(" item?.reg_fields",  item?.reg_fields)

                const dynamicFields = Object.keys(
                  item?.reg_fields || {}
                )
                  .map((key) => {

                    if (hiddenFields.has(key)) {
                      return null;
                    }

                    return {
                      key,
                      label: steps_labels?.[key] || fieldMap[key]?.label || UCWords(key.replaceAll("_", " ")),
                      type: fieldMap[key]?.type || "text",
                      keys: [key],
                    };
                  })
                  .filter(Boolean)

                return (

                  <div
                    className="mentro_details mentro_with_object mb-2 mb-md-4 d-flex  flex-wrap"
                    key={item.id}
                  >
                    <div className="mentro_details_leftbar">
                      <div className="mentor_pic">
                        <img
                          src={
                            item?.mentee_image ||
                            item?.reg_fields?.image ||
                            item?.image ||
                            NoImage
                          }
                          alt="profilePicture"
                          onError={(e) => {
                            e.target.src = NoImage;
                          }}
                        />

                      </div>
                      {item?.reg_fields?.linkedin && <div className="profile_btn mt-3">
                        <a
                          href={item.reg_fields?.linkedin}
                          className="link_btn btn btn_red m-0"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={"/assets/images/linkedin.png"}
                            className="me-2 bg-white"
                            alt="LinkedIn"
                          />{""}
                          Linkedin Profile
                        </a>
                      </div>}
                      {item.mentee_diagnostics_sdate !== "0" && (
                        <div className="profile_btn mt-3">
                          <Link
                            to=""
                            className="link_btn btn btn_red m-0"
                            onClick={(e) => {
                              viewToolkit(
                                e,
                                item.mentee_id,
                                item.mentor_id,
                                item.mentee_diagnostics,
                                item.mentee_diagnostics_sdate
                              );
                            }}
                          >
                            <img
                              src="/assets/images/notification_icon.png"
                              alt="review_icon"
                              className="me-2 bg-white"
                            />
                            {(subDomainPath === "siddev" || subDomainPath === "siduat" || subDomainPath === "sid") ? "Self Assessment Tool" : "Goal Setting"}
                          </Link>
                        </div>
                      )}
                      <div className="extar_info_link">
                        <ul className="px-0 pt-2 mentor_log">
                          {(subDomainPath !== 'siddev' || subDomainPath !== 'siduat' || subDomainPath !== 'sid') && (
                            <li>
                              {item?.mn_open_to_talk == 1 && (
                                <Tooltip
                                  size="4xl"
                                  title={<h5>{config?.mn_open_to_talk}</h5>}
                                  describeChild
                                  arrow
                                >
                                  <img alt="" src={imgPath + "usermind.svg"} />
                                </Tooltip>
                              )}
                            </li>
                          )}
                          {(subDomainPath !== 'siddev' || subDomainPath !== 'siduat' || subDomainPath !== 'sid') && (
                            <li>
                              {item?.mn_loking_for_coach == 1 && (
                                <Tooltip
                                  size="4xl"
                                  title={
                                    <h5>{config?.mn_loking_for_coach}</h5>
                                  }
                                  describeChild
                                  arrow
                                >
                                  <img alt="" src={imgPath + "useraward.svg"} />
                                </Tooltip>
                              )}
                            </li>
                          )}
                          <li>
                            {item?.mentor_lgbtq_discussion == 1 && (
                              <Tooltip
                                size="4xl"
                                title={
                                  <h5>{config?.LGBTQ_discussion}</h5>
                                }
                                describeChild
                                arrow
                              >
                                <img alt="" src={rainbow} />
                              </Tooltip>
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="mentro_details_sidebar">
                      <div className="row ">
                        <Col xl={4}>
                          <div className="d-flex ">
                            <div className="name_info main_area_Details">
                              <h4 className="mb-0">
                                {`${item?.reg_fields?.first_name || ""} ${item?.reg_fields?.last_name || ""}`.trim() ||
                                  item?.mentee_name}
                              </h4>

                              {/* {item?.reg_fields?.organization && (
                                <h5>
                                  <span className="d-block">
                                    {item?.reg_fields?.organization}
                                  </span>
                                </h5>
                              )}

                              {item?.reg_fields?.position && (
                                <h5>{item?.reg_fields?.position}</h5>
                              )}

                              {item?.reg_fields?.domains && (
                                <h5>
                                  {item?.reg_fields?.domains
                                    ?.split("||")
                                    ?.map((domain) => domain.trim())
                                    ?.filter(Boolean)
                                    ?.join(", ")}
                                </h5>
                              )} */}
                            </div>
                          </div>
                        </Col>

                        <Col xl={8} className="">
                          <div className="current-mentees  profile_btn d-sm-flex  justify-content-xl-end ">
                            <button
                              className="link_btn btn btn_red"
                              onClick={() => {
                                setSessionModel(true);
                                setModelData(item);
                              }}
                            >
                              Mentoring Session
                            </button>

                            {item.mentee_review && (
                              <button
                                className="link_btn btn btn_red"
                                onClick={() => {
                                  setModel(true);
                                  setModelData(item);
                                }}
                              >
                                Feedback
                              </button>
                            )}
                            <button
                              className="link_btn btn btn_red"
                              onClick={() => handleClickChat(item)}
                            >
                              <img
                                src="/assets/images/msg.png"
                                alt="msg_icon"
                                className="me-2 bg-white"
                              />{""}
                              Send Message
                            </button>

                            <button
                              className="link_btn btn btn_red"
                              onClick={(e) => {
                                writeReview(
                                  e,
                                  item.mentee_id,
                                  item.mentor_id,
                                  item.mentor_review
                                );
                              }}
                            >
                              <img
                                src="/assets/images/review_blue.png"
                                alt="review_icon"
                                className="me-2 bg-white"
                              />
                              {item.mentor_review === "" &&
                                "Write A Review"}
                              {item.mentor_review !== "" &&
                                "Update Review"}
                            </button>
                            {(item.mentor_termination_status === 0 ||
                              item.mentor_termination_status === "") && (
                                <button
                                  className="link_btn btn btn_red"
                                  onClick={(e) => {
                                    endRelationshipModal(
                                      e,
                                      item.mentee_id,
                                      item.mentor_id,
                                      item.mentor_review,
                                      item.id
                                    );
                                  }}
                                >
                                  <img
                                    src="/assets/images/review_blue.png"
                                    alt="review_icon"
                                    className="me-2 bg-white"
                                  />{""}
                                  Terminate the Relationship
                                </button>
                              )}
                            {/* Schedule Meeting should always be available */}
                            <button
                              className="link_btn btn btn_red"
                              onClick={(e) => {
                                handleSchedule(e, item);
                              }}
                            >
                              <img
                                src="/assets/images/review_blue.png"
                                alt="review_icon"
                                className="me-2 bg-white"
                              />{""}
                              Schedule Meeting
                            </button>
                            {(item.mentor_termination_status === 1 ||
                              item.mentor_termination_status === 2) && (
                                <Button
                                  to=""
                                  className="link_btn btn btn_red disabledCursor"
                                  title={"You have already raised the termination request. Please wait for the admin to review"}
                                  onClick={callAFun}
                                >
                                  <img
                                    src="/assets/images/review_blue.png"
                                    alt="review_icon"
                                    className="me-2 bg-white"
                                  />{" "}
                                  Terminate the Relationship
                                </Button>
                              )}
                            <Dropdown>
                              <Dropdown.Toggle as={CustomToggle} />
                              <Dropdown.Menu
                                style={{ marginTop: "10px" }}
                                size="sm"
                                title=""
                              >
                                <Dropdown.Item
                                  onClick={(e) => {
                                    viewReportModal(e, item);
                                  }}
                                >
                                  Report
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </Col>
                      </div>

                      <ul className="date_list py-2 py-md-4">
                        <div className="d-flex align-items-center gap-5">
                          <li className="d-flex align-items-center">
                            <div className="date_icon">
                              <img
                                src="/assets/images/calender.png"
                                alt="calender_image"
                              />
                            </div>
                            <div className="date_content ps-2">
                              <span className="d-block">
                                Session start date
                              </span>
                              <span className="d-block date" style={{ padding: '0px' }}>
                                {item.session_start_date}
                              </span>
                            </div>
                          </li>

                          <li className="d-flex align-items-center">
                            <div className="date_icon">
                              <img
                                src="/assets/images/calender.png"
                                alt="calendericon"
                              />
                            </div>
                            <div className="date_content ps-2">
                              <span className="d-block">
                                Session end date
                              </span>
                              <span className="d-block date" style={{ padding: '0px' }}>
                                {item.session_end_date}
                              </span>
                            </div>
                          </li>
                        </div>

                        {item.mentee_resume && (
                          <li className="d-sm-flex align-items-center">
                            <div className="date_icon">
                              <img
                                src="/assets/images/pdf.png"
                                alt="download-icon"
                              />
                            </div>

                            <div className="date_content ps-2">
                              <Link
                                to=""
                                download
                                className="d-block date color_red"
                                onClick={(e) =>
                                  downloadResume(e, item.mentee_resume)
                                }
                                target="_blank"
                              >
                                {"Download Resume"}
                              </Link>
                            </div>
                          </li>
                        )}

                        {/* <li className="d-flex align-items-center">
                          &nbsp;
                        </li> */}
                      </ul>

                      {dynamicFields.map((field, index) => {

                        const value = getFieldValue(item, field.keys);

                        // console.log("value::::::::",value)
                        // console.log("field.key::::::::",field?.key)

                        // enable disable support
                        if (item?.field_settings?.[field.key]?.is_enable === 0) {
                          return null;
                        }

                        // empty
                        if (isEmptyValue(value) && field.type !== "board_roles") {
                          return null;
                        }

                        // empty array
                        if (field.type === "array" && normalizeArray(value).length === 0) {
                          return null;
                        }

                        let displayValue = value;

                        // if (field.key == "domains" && displayValue) {
                        //   displayValue = UCWords(
                        //     String(displayValue).replaceAll("||", ", ")
                        //   );
                        // }

                        if (field.key == "domains" && displayValue) {

                          displayValue = UCObjective(displayValue)
                        }

                        if (field.key == "objective" && displayValue) {
                          displayValue = UCObjective(displayValue)
                        }

                        if (field.key == "past_board_roles" && displayValue) {
                          displayValue = UCObjective(displayValue)
                        }

                        return (
                          <div className={field.key === "past_board_roles" ? "" : "mentro_text"} key={field.key + index}>
                            <h3 className="mb-1">{field.label == "Past Board Roles" ? "Current / Past Board Roles" : field.label}</h3>

                            {field.type === "text" &&
                              (field.key === "about" ? (
                                <div>{displayValue}</div>
                              ) : (
                                <ul>
                                  <li>{displayValue}</li>
                                </ul>
                              ))}

                            {field.type == "array" && (
                              (field.key == "objective" &&
                                <ul>
                                  {displayValue.map((dataItem, idx) => (
                                    <li key={dataItem.id}>
                                      {dataItem}
                                    </li>
                                  )
                                  )}
                                </ul>
                              )
                            )}

                            {field.type == "array" && (
                              (field.key == "domains" &&
                                <ul>
                                  {displayValue.map((dataItem, idx) => (
                                    <li key={dataItem.id}>
                                      {dataItem}
                                    </li>
                                  )
                                  )}
                                </ul>
                              )
                            )}
                            {field.type == "array" && (
                              (field.key == "past_board_roles" &&
                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "10px" }}>
                                  {displayValue.map((dataItem, idx) => (
                                    <li key={dataItem.id || idx} style={{ listStyleType: "disc", marginBottom: "4px", fontSize: "14px" }}>
                                      {dataItem}
                                    </li>
                                  )
                                  )}
                                </ul>
                              )
                            )}

                            {field.type === "array" && field.key !== "objective" && field.key !== "domains" && field.key !== "past_board_roles" && (
                              <ul>
                                {normalizeArray(value).map(
                                  (dataItem, idx) => (
                                    <li key={dataItem.id}>
                                      {dataItem}
                                    </li>
                                  )
                                )}
                              </ul>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )
              })}
            </Slider>
            {(menteeRequestData.length === 0 || pagination?.total === 0) && (
              <div className="text-center">No current mentees found.</div>
            )}
          </div>
        </div>
      </div >
      {toolkitModalShow && (
        <DToolkit
          show={toolkitModalShow}
          userdata={toolkitData}
          onHide={() => setToolkitModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {
        sessionModel && (
          <MentoringSession
            show={sessionModel}
            userInfo={userInfo}
            actions={actions}
            userdata={modelData}
            onHide={() => setSessionModel(false)}
            refreshMentors={refreshMentors}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        reportModalShow && (
          <ReportUser
            show={reportModalShow}
            userdata={userData2}
            onHide={() => setReportModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        scheduleModal && (
          <ScheduleMeetingModal
            show={scheduleModal}
            scheduleUser={scheduleUser}
            onHide={() => setScheduleModal(false)}
            setting={setting}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        model && (
          <Feedback
            show={model}
            userdata={modelData}
            onHide={() => setModel(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }
      {
        modalShow && (
          <Details
            show={modalShow}
            userdata={userData}
            onHide={() => setModalShow(false)}
            refreshList={refreshMentors}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }

      {
        relationModalShow && (
          <Relationship
            show={relationModalShow}
            endrelationship={endRelationship}
            onHide={() => setRelationModalShow(false)}
            refreshList={refreshMentors}
            centered
            size="xl"
            className="mentor_modal"
          />
        )
      }

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </div >
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  steps_labels: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    loadData: PropTypes.func.isRequired,
    loadRegData: PropTypes.func.isRequired,
  }).isRequired,
  menteeRequestData: PropTypes.array.isRequired,
  userInfo: PropTypes.shape({
    role_id: PropTypes.number,
    image: PropTypes.string,
  }).isRequired,
  pagination: PropTypes.object.isRequired,
  setting: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    menteeRequestData: state.menteeRequestData,
    isAuth: state.isAuth,
    userInfo: state.userInfo,
    pagination: state.pagination,
    setting: state.setting,
    steps_labels: state.steps_labels,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...menteesRequestAction, ...baseActions, ...settingActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
